import { useEffect, useState } from 'react'
import { liveQuery } from 'dexie'
import { offlineDB } from './db'

const ORDER_ACTION_TYPES = new Set([
    'create_order',
    'mark_item_ready',
    'update_status',
    'cancel_order',
    'void_item',
    'earn_points_offline',
])

export function usePendingSyncCount() {
    const [count, setCount] = useState(0)

    useEffect(() => {
        const computeCount = (pending) => {
            const orderRefs = new Set()
            for (const action of pending) {
                if (!ORDER_ACTION_TYPES.has(action.type)) continue
                const ref = action.type === 'create_order' ? action.clientRef : action.payload?.orderClientRef
                if (ref) orderRefs.add(ref)
            }
            return orderRefs.size
        }

        const subscription = liveQuery(() =>
            offlineDB.syncQueue.where('status').equals('pending').toArray()
        ).subscribe({
            next: (pending) => setCount(computeCount(pending)),
            error: (err) => console.error('usePendingSyncCount liveQuery error:', err),
        })

        return () => subscription.unsubscribe()
    }, [])

    return count
}